var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCardHelp03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13333 38.875C2.50773 38.875 2 38.3461 2 37.6944V8.18056C2 7.52889 2.50773 7 3.13333 7C3.75893 7 4.26667 7.52889 4.26667 8.18056V37.6944C4.26667 38.3461 3.75893 38.875 3.13333 38.875",
    fill: "#9063CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8 42.4164H6.53333C4.0332 42.4164 2 40.2985 2 37.6942C2 37.0426 2.50773 36.5137 3.13333 36.5137C3.75893 36.5137 4.26667 37.0426 4.26667 37.6942C4.26667 38.9976 5.2844 40.0553 6.53333 40.0553H42.8C43.4256 40.0553 43.9333 40.5842 43.9333 41.2359C43.9333 41.8876 43.4256 42.4164 42.8 42.4164",
    fill: "#F5B6CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8003 42.4167C42.1747 42.4167 41.667 41.8878 41.667 41.2361C41.667 40.5844 42.1747 40.0556 42.8003 40.0556C44.0515 40.0556 45.067 38.9978 45.067 37.6944V8.18056C45.067 7.52889 45.5747 7 46.2003 7C46.8259 7 47.3337 7.52889 47.3337 8.18056V37.6944C47.3337 40.2988 45.3005 42.4167 42.8003 42.4167",
    fill: "#00CCEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2 9.36111H3.13333C2.50773 9.36111 2 8.83222 2 8.18056C2 7.52889 2.50773 7 3.13333 7H46.2C46.8256 7 47.3333 7.52889 47.3333 8.18056C47.3333 8.83222 46.8256 9.36111 46.2 9.36111",
    fill: "#00C389"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40041 40.0558C5.11708 40.0558 4.83375 39.9448 4.61388 39.7252C4.16281 39.2719 4.14921 38.5258 4.58441 38.0559L17.9351 23.6295C18.3703 23.162 19.0911 23.1478 19.5376 23.5988C19.9887 24.0521 20.0023 24.8006 19.5671 25.2681L6.21641 39.6945C5.99428 39.9353 5.69735 40.0558 5.40041 40.0558",
    fill: "#FF7F37"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_512_5117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 7,
    width: 27,
    height: 34
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4482 7H47.3336V40.0556H21.4482V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_512_5117)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9336 40.0557C43.6525 40.0557 43.3692 39.947 43.1493 39.7275L30.057 26.6658L25.4693 31.447C25.025 31.9075 24.3088 31.9075 23.8645 31.447L21.7814 29.2748C21.3372 28.812 21.3372 28.0659 21.7814 27.6055C22.2234 27.1427 22.9397 27.1427 23.384 27.6055L24.6669 28.9419L29.2342 24.1843C29.2388 24.1819 29.241 24.1772 29.2433 24.1748L45.3978 7.34482C45.8421 6.88441 46.5584 6.88441 47.0026 7.34482C47.4446 7.8076 47.4446 8.55371 47.0026 9.01649L31.6596 24.9965L44.7178 38.0227C45.1689 38.4737 45.1848 39.2198 44.7518 39.692C44.5297 39.9329 44.2328 40.0557 43.9336 40.0557",
    fill: "#FDDA24"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_512_5117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 22,
    height: 23
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7H23.7155V29.6197H2V7Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_512_5117)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5819 29.6195C22.2918 29.6195 22.0016 29.5039 21.7795 29.2748L2.3315 9.01413C1.8895 8.55371 1.8895 7.8076 2.3315 7.34482C2.77577 6.88441 3.49203 6.88441 3.93403 7.34482L23.3843 27.6032C23.8263 28.0659 23.8263 28.812 23.3843 29.2748C23.1622 29.5039 22.872 29.6195 22.5819 29.6195",
    fill: "#FF7F37"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardHelp03);
export default __webpack_public_path__ + "static/media/icon_card_help_03.371daddb78ee8d0edf043d6d67362946.svg";
export { ForwardRef as ReactComponent };